export default __webpack_public_path__ + "maps-guides-styles-layers-fill-extrusion-layer-1200-3d81434332af6182872f517983352a0f.png";